import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'

import { getCustomerQuotes } from '../../components/customerQuotes'
import { Section } from '../../components/Section'

export function SectionPricingQuotes() {
  const intl = useIntl()
  const columns = [
    getCustomerQuotes(
      ['OskarRemoteSenseiSupport', 'RomanKubaTsetKnowledgePanel'],
      intl
    ),
    getCustomerQuotes(
      ['KatsiarynaEnteractiveSupport', 'PierreAndreWeCasaSearch'],
      intl
    ),
    getCustomerQuotes(
      ['NinaWarneckeNELESupport', 'MartijnSalonizedAdoption'],
      intl
    ),
    getCustomerQuotes(
      ['EricJobSauceSimplicity', 'ClaireVilletDisplayceAsk'],
      intl
    ),
  ]

  return (
    <Section background="moon-dust-lighter">
      <div className="margin-horizontal-auto" style={{ maxWidth: 1400 }}>
        <h2 className="font-size-2 font-weight-medium text-align-center line-height-title font-family-title">
          <FormattedMessage
            id="pricing.quotes.title"
            defaultMessage="They say it better than we do."
          />
        </h2>
        <div className="grid-12 grid-gap-16 padding-top-60 padding-bottom-40">
          {columns.map((column, columnIndex) => (
            <div
              key={columnIndex}
              className="grid-span-3 grid-span-6-medium grid-span-12-small flexbox flexbox-column grid-gap-16"
            >
              {column.map((quote, cardIndex) => {
                const variant =
                  (cardIndex + columnIndex) % 2 === 0 ? 'white' : 'dust'

                return (
                  <div
                    key={cardIndex}
                    className={classNames(
                      'padding-24 radius-larger flexbox flexbox-column',
                      variant === 'white'
                        ? 'background-shade-100 '
                        : 'background-shade-100  height-full'
                    )}
                  >
                    <div
                      className={classNames(
                        'flexbox flexbox-gap-12  margin-bottom-12',
                        variant === 'white'
                          ? 'flexbox-column flexbox-align-start'
                          : 'flexbox-align-center'
                      )}
                    >
                      <ImgSanity
                        src={quote.pictureUrl}
                        alt={quote.name}
                        width={variant === 'white' ? 64 : 40}
                        className="radius-round"
                      />
                      <div>
                        <div className="font-weight-medium font-size-6 font-family-title">
                          {quote.name}
                        </div>
                        <div className="font-size-7">{quote.title}</div>
                      </div>
                    </div>
                    <div className="font-size-6">{quote.testimonial}</div>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </Section>
  )
}
